import { ENUM_ACTIVE_CHECKBOX, ENUM_IMAGE_LAYOUT } from 'constants/enum';
import { TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';

const Required = require('assets/resources/Required.svg').default;

export const TitleViewOnly = (props) => {
  const { data, showTitleNull = false, isShowVietName } = props;

  if (!data?.title && !showTitleNull) return null;

  const TEXT_QUESTION_NUMBER = isShowVietName ? TEXT_COMMON.QUESTION_NUMBER_VIETNAM : TEXT_COMMON.QUESTION_NUMBER;

  const titleNumber = data.question_number ? TEXT_QUESTION_NUMBER.replace('${question_number}', data.question_number) : '';
  const title = data?.title.replace(/\r\n/g, '<br />') || TEXT_CREATE_SURVEY.TITLE_PARAGRAPH;

  return (
    <p className="text-black-102 pb-4 w-full flex items-start gap-1 break-all">
      {data.is_required && <img className="mt-2" src={Required} alt="required" width={7} height={7} />}
      <span dangerouslySetInnerHTML={{ __html: `${titleNumber}${title}` }} />
    </p>
  );
};

export const ImageViewOnly = (props) => {
  const { data } = props;

  if (!data.images?.[0]) return null;
  const imagePreview = data.images?.[0];

  return (
    <div className="w-full mb-4" style={{ display: 'flex', justifyContent: imagePreview?.image_layout ?? ENUM_IMAGE_LAYOUT.LEFT }}>
      <div className="image-preview-view-only">
        <img
          src={imagePreview?.url_preview}
          alt="Image Preview"
          style={{ width: imagePreview?.size?.width, height: imagePreview?.size?.height }}
          className="image-preview"
        />
      </div>
    </div>
  );
};

export const DescriptionViewOnly = (props) => {
  const { data } = props;

  return (
    data.active_checkbox?.indexOf(ENUM_ACTIVE_CHECKBOX.EXPLANATION) !== -1 &&
    data?.description && <p className="text-secondary-354 mb-4 text-base break-all">{data?.description ?? ''}</p>
  );
};
